import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";

export function NewFolderDialog({ open, onOpenChange, cur, scope, ownerId, queryKey }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const qc = useQueryClient();
  const [folderName, setFolderName] = useState("");

  const folderMut = useMutation({
    mutationFn: async () => (await api.post("/drive/folders", { scope, owner_id: ownerId || undefined, name: [cur, folderName.trim()].filter(Boolean).join("/") })).data,
    onSuccess: (d) => {
      toast.success(t("driveExplorer.folderCreatedToast", { name: d.name }));
      onOpenChange(false);
      setFolderName("");
      qc.invalidateQueries({ queryKey });
    },
    onError: (e) => toast.error(fmtErr(e)),
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="drive-new-folder-dialog">
        <DialogHeader><DialogTitle>{t("driveExplorer.newFolder")} {cur ? t("driveExplorer.insideX", { path: cur }) : ""}</DialogTitle></DialogHeader>
        <div className="space-y-1.5">
          <Label>{t("driveExplorer.folderNameL")}</Label>
          <Input value={folderName} onChange={(e) => setFolderName(e.target.value)} placeholder={scope === "shared" ? "e.g. HR or HR/Policies" : "e.g. Receipts"} data-testid="drive-new-folder-input" />
          {scope === "shared" && !(user?.is_super_admin || user?.is_admin) && !cur && (
            <p className="text-xs text-slate-500">{t("driveExplorer.sharedFolderNote")}</p>
          )}
        </div>
        <DialogFooter>
          <Button onClick={() => folderMut.mutate()} disabled={!folderName.trim() || folderMut.isPending} data-testid="drive-new-folder-submit">{t("common.create")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
